import { LogoutOutlined } from '@ant-design/icons'
import { Button } from 'antd'

function ClickableItem({
  icon,
  className = '',
  onClick,
  messageKey,
  defaultLabel,
  testId,
}) {
  return (
    <div className="user-menu-item">
      <Button
        {...(icon ? { icon } : {})}
        type="text"
        className={className}
        onClick={onClick}
        data-testid={testId || null}
      >
        <span>{defaultLabel || null}</span>
      </Button>
    </div>
  )
}

function UserMenuContent(props) {
  const { onLogout, username, userIsSignedIn, toggleMenu } = props
  return (
    <div className="content" id="user-menu-popover">
      {/* Client ID if provided, is displayed as the first   menu item */}
      {userIsSignedIn ? (
        username && (
          <div className="user-details">
            <div className="username">{username}</div>
            <div data-testid="separator" className="separator" />
          </div>
        )
      ) : (
        <Button size="small" variant="text">
          <span>Sign In</span>
        </Button>
      )}
      {/* Any other items required in menu can go here */}
      <></>
      {/* Logout button at the bottom od the popover */}
      {userIsSignedIn && (
        <ClickableItem
          icon={<LogoutOutlined />}
          onClick={onLogout}
          className="logout"
          messageKey="auth.logout"
          defaultLabel="Logout"
          testId="logout-button"
        />
      )}
    </div>
  )
}

export default UserMenuContent
